import { ref } from 'vue';

const EMPTY = { total: null, from: null, to: null };

/**
 * Contador de registros de una tabla paginada ("Mostrando 1–10 de 37 registros").
 *
 * Guarda `total`, `from` y `to` tal como los devuelve el paginador de Laravel
 * (`response.data.value`) para pasárselos a `PaginateComponent`. El total es
 * siempre el del conjunto filtrado, no el de la página visible.
 */
export function usePaginationInfo() {
  const paginationInfo = ref({ ...EMPTY });

  /** Recibe el objeto de página de la API (el que trae `data`, `total`, `from`, `to`…). */
  const setPaginationInfo = (page) => {
    paginationInfo.value = {
      total: Number.isFinite(page?.total) ? page.total : null,
      from: page?.from ?? null,
      to: page?.to ?? null,
    };
  };

  const resetPaginationInfo = () => {
    paginationInfo.value = { ...EMPTY };
  };

  return { paginationInfo, setPaginationInfo, resetPaginationInfo };
}
